import { Board } from './board.js'
import { BoardHistory } from './board-history.js'
import { BoardQuery } from './board-query.js'
import { BoardMutation } from './board-mutation.js'
import { BoardSubscription } from './board-subscription.js'
import { BoardSubscriber, BoardHistoryEntitySubscriber } from './event-subscriber.js'

export const entities = [Board, BoardHistory]
export const resolvers = [BoardQuery, BoardMutation, BoardSubscription]
export const subscribers = [BoardSubscriber, BoardHistoryEntitySubscriber]
